import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedLocationList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseLocations {
  search?: string;
  ordering?: string;
}

function useLocations({
  search,
  ordering,
}: IUseLocations): UseInfiniteQueryResult<AxiosResponse<PaginatedLocationList>> {
  const fetchLocations = useCallback(
    ({
      pageParam = { limit: '20', offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedLocationList>> => {
      const params = pageParam;

      if (search) {
        params.search = search;
      }

      if (ordering) {
        params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
      }

      return client.get(`locations/?${encodeUrlParams(params)}`);
    },
    [ordering, search],
  );

  return useInfiniteQuery(['locations', search, ordering], fetchLocations, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export default useLocations;
